import React from "react";
import { IWave } from "../../store/types";
import { styleName } from "../frameHelper";
import { styleClassName } from "../styleHelper";
import { ScreenProps } from "../types";
import { FirebaseContainer, useStoreData } from "./FirebaseProvider";
import { WaveProps } from "./types";

/**
 * 0 Height elements to cleanly align items
 * Note: There is nothing unique about each item
 */
function EmptyFix() {
  return (
    <>
      {Array(6)
        .fill(null)
        .map((_, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className="wave-empty-actor" key={i} />
        ))}
    </>
  );
}

function SimplifiedWave(props: WaveProps) {
  const { state, onFinish } = props;
  const className = styleClassName("wave nes-container with-title");
  return (
    <div
      role="button"
      className={className}
      onClick={onFinish}
      onKeyDown={e => {
        if (e.key === "Enter") onFinish();
      }}
      tabIndex={0}
    >
      <p className="title">{state.name}</p>
      <div className="wave-actors">
        {state.actors.map(({ actor }) => (
          <div style={styleName(`${actor.frame.name}1`)} key={actor.id} />
        ))}
        <EmptyFix />
      </div>
    </div>
  );
}

// separate component since useStoreData needs to be inside a FirebaseContainer
function LoadedWaves({ dispatch }: Pick<ScreenProps, "dispatch">) {
  const waves: IWave[] = useStoreData();
  const onFinish = (wave: IWave) =>
    dispatch({
      type: "state/loadWave",
      payload: { screen: "#battle", wave }
    });

  return (
    <div id="multiplayer-wave-loader-screen">
      {waves.map((state: IWave) => {
        return (
          <SimplifiedWave
            key={state.id}
            state={state}
            onFinish={() => onFinish(state)}
          />
        );
      })}
    </div>
  );
}

export default function WavesViewer(props: ScreenProps) {
  const { dispatch } = props;
  return (
    <FirebaseContainer>
      <LoadedWaves dispatch={dispatch} />
    </FirebaseContainer>
  );
}
